import { lazy } from "react";
import { Navigate } from "react-router-dom";

import SettingsIcon from "@mui/icons-material/Settings";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";

const BrandList = lazy(() => import("../components/brandList"));
const Brand = lazy(() => import("../components/brand"));

const brandRoute = {
  icon: SettingsIcon,
  name: "Settings",
  link: "/settings",
  path: "settings",
  index: 25,
  children: [
    {
      path: "brand",
      element: <BrandList />,
      name: "Brand",
      link: "/settings/brand",
      icon: BrandingWatermarkIcon,
      permission: "Brand-Read",
      index: 5,
      superAdminView: false,
    },
    {
      path: "brand/create",
      element: <Brand />,
    },

    {
      path: "brand/:id",
      element: <Brand />,
    },
    {
      path: "",
      element: <Navigate to="brand" replace />,
    },
  ],
};
export default brandRoute;
